/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React from 'react';
import { observer } from 'mobx-react';
import { makeApi, URLS } from 'Utils/apiUtil';
import { userDetail } from 'Stores/userDetail';
import Utils from 'Utils/utils';
import { inputBoxPopupState } from 'Components/common/inputPopup';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import { loginValidate } from 'Utils/commonApi';
import PurchaseStatusPopup, {
  purchaseStatusPopupState,
} from 'Components/common/purchaseStatusPopup';
import { ReactComponent as DeleteToIcon } from '../../../assets/svg/delete-to.svg';

const TeamManage = observer(props => {
  const [teamData, setTeamData] = React.useState({});
  const [memberData, setMemberData] = React.useState([]);
  const { noOfSeatsEligible, noOfSeatsUsed } = userDetail.userInfo;

  const constructTeamData = () => {
    const config = {
      url: URLS.getTeamDetails ? URLS.getTeamDetails : '',
      method: 'GET',
    };
    makeApi(config)
      .then(response => {
        if (
          response &&
          response.status &&
          response.status === 200 &&
          response.data
        ) {
          setTeamData(response.data);
          if (response.data.members && response.data.members.length)
            setMemberData(response.data.members);
        }
      })
      .catch(error => {
        console.log('Get Team Details Error ', error);
      });
  };

  const adduserAction = () => {
    if (
      noOfSeatsUsed &&
      noOfSeatsEligible &&
      noOfSeatsUsed < noOfSeatsEligible
    ) {
      const firstnameBlurCallBack = inputval => {
        if (inputval.fname && inputval.fname.length)
          document.getElementById('errfname').classList.remove('errorShown');
        else document.getElementById('errfname').classList.add('errorShown');
      };

      const lastnameBlurCallBack = inputval => {
        if (inputval.lname && inputval.lname.length)
          document.getElementById('errlname').classList.remove('errorShown');
        else document.getElementById('errlname').classList.add('errorShown');
      };

      const emailBlurCallBack = inputval => {
        if (inputval.email && inputval.email.length)
          document.getElementById('erremail').classList.remove('errorShown');
        else document.getElementById('erremail').classList.add('errorShown');
      };

      const callback = inputVal => {
        inputBoxPopupState.setShowPopup(false);
        const postData = {};
        postData.email = inputVal.email ? inputVal.email : '';
        postData.firstName = inputVal.fname ? inputVal.fname : '';
        postData.lastName = inputVal.lname ? inputVal.lname : '';
        postData.status = 'ACTIVE';
        const config = {
          url: URLS.teamInvite ? URLS.teamInvite : '',
          method: 'POST',
          data: postData,
        };
        makeApi(config)
          .then(response => {
            if (response && response.data && response.data.code) {
              const responseCode = response.data.code;
              let msgStr = '';
              if (responseCode === 200) {
                loginValidate(false);
                constructTeamData();
                msgStr = `We have sent an Invitation email to ${inputVal.email}`;
              } else if (responseCode === 1013) {
                msgStr = 'This user is already part of your team plan';
              } else if (responseCode === 1014) {
                msgStr = 'Email is already associated with another enterprise.';
              } else if (responseCode === 1015) {
                msgStr = 'You have reached the limit of team members';
              } else if (responseCode === 1012) {
                msgStr = 'Sorry, something went wrong. Please try again"';
              }
              if (msgStr !== '')
                purchaseStatusPopupState.setToastMsg(
                  null,
                  null,
                  null,
                  null,
                  null,
                  msgStr,
                );
            } else if (
              response.response &&
              response.response.status &&
              response.response.status === 500
            ) {
              purchaseStatusPopupState.setToastMsg(
                null,
                null,
                null,
                null,
                null,
                'Sorry, something went wrong. Please try again or Contact <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a>',
              );
            }
          })
          .catch(error => {
            console.log('Get Team Details Error ', error);
          });
      };

      const inputObj = {
        id: 'fname',
        type: 'text',
        placeholder: 'First Name',
        errorMsg: 'First name is required.',
        onblurCallback: firstnameBlurCallBack,
      };

      const inputObj1 = {
        id: 'lname',
        type: 'text',
        placeholder: 'Last Name',
        errorMsg: 'Last name is required.',
        onblurCallback: lastnameBlurCallBack,
      };

      const inputObj2 = {
        id: 'email',
        type: 'email',
        placeholder: 'Enter your work email',
        errorMsg: 'Email is required.',
        onblurCallback: emailBlurCallBack,
      };

      const tempCallObj = {
        title: 'Add a New user',
        inputBoxArr: [inputObj, inputObj1, inputObj2],
        actionBtnText: 'Add User',
        callback,
      };
      inputBoxPopupState.setPopupValues(tempCallObj);
      inputBoxPopupState.setShowPopup(true);
    } else {
      const callback = () => {
        window.location.hash = '#pricingEnterpriseContact';
      };
      confirmationPopupState.setPopupValues({
        title: 'Add User',
        content:
          'You have used all the seats available in your current plan. To add more users, please contact sales.',
        actionBtnText: 'Contact us',
        needCancelBtn: false,
        callback,
      });
      confirmationPopupState.setShowPopup(true);
    }
  };

  const buymoreCredits = () => {
    const callback = () => {};
    confirmationPopupState.setPopupValues({
      title: 'Contact Us',
      content:
        'Please write to us at <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a> to buy more credits.',
      actionBtnText: 'OK',
      needCancelBtn: false,
      callback,
    });
    confirmationPopupState.setShowPopup(true);
  };

  const blockUser = e => {
    const { currentTarget } = e;
    const userEmail = currentTarget.getAttribute('data-email');
    const memberId = currentTarget.getAttribute('data-memid');

    const callback = () => {
      const config = {
        url: URLS.removeUser ? URLS.removeUser : '',
        method: 'POST',
        data: { memberId },
      };
      makeApi(config)
        .then(response => {
          if (
            response &&
            response.status &&
            response.status === 200 &&
            response.data &&
            response.data.code &&
            response.data.code === 200
          ) {
            loginValidate(false);
            constructTeamData();
            purchaseStatusPopupState.setToastMsg(
              null,
              null,
              null,
              null,
              null,
              `Removed the user ${userEmail} from the team!`,
            );
          }
        })
        .catch(error => {
          console.log('Get Team Details Error ', error);
        });
    };

    confirmationPopupState.setPopupValues({
      title: 'Remove User',
      content: `Are you sure you want to remove ${userEmail} from your team plan ?`,
      actionBtnText: 'Confirm',
      callback,
    });
    confirmationPopupState.setShowPopup(true);
  };

  React.useEffect(() => {
    constructTeamData();
  }, []);

  return (
    <div className="teamManagePage">
      <PurchaseStatusPopup />
      <div className="teamCont">
        <section className="headerCont">
          <div className="rightSection">
            <div className="manage-team-header">
              <div className="page-title-text">Enterprise Users </div>(
              {noOfSeatsUsed} / {noOfSeatsEligible} seats used)
            </div>
            <div className="buttonParentCont">
              <div className="addUserCont buttonCont" onClick={adduserAction}>
                <div className="addUser button">Add User</div>
              </div>
              <div className="addUserCont buttonCont" onClick={buymoreCredits}>
                <div className="addUser button">Buy More Credits</div>
              </div>
            </div>
          </div>
        </section>
        <section
          className={`bodyCont ${
            !Utils.isCreditBasedSubscription() ? ' viewsDownloadsView' : ''
          }`}
        >
          <div className="tableHeader">
            <div className="title-name email">Email</div>
            {!Utils.isCreditBasedSubscription() ? (
              <>
                <div className="title-name views">Views Used</div>
                <div className="title-name downloads">Downloads Used</div>
              </>
            ) : (
              <div className="title-name credits">Credits Used</div>
            )}
            <div className="title-name status">Status</div>
            <div className="title-name options">Options</div>
          </div>
          <div className="tableBody">
            {memberData &&
              memberData.map((value, key) => {
                const {
                  status,
                  memberId,
                  emailId,
                  views,
                  downloads,
                  lbCredits,
                  role,
                  secondaryEmailId = null,
                } = value || {};
                if (status !== null && status !== 'INACTIVE')
                  return (
                    <div key={key} mid={memberId} className="userDetails">
                      <div className="userValue email-value">
                        <span>{emailId || '-'}</span>{' '}
                        <span>
                          {secondaryEmailId ? `(${secondaryEmailId})` : ''}
                        </span>
                      </div>
                      {!Utils.isCreditBasedSubscription() ? (
                        <>
                          <div className="userValue views-value">
                            {views || '0'}
                          </div>
                          <div className="userValue downloads-value">
                            {downloads || '0'}
                          </div>
                        </>
                      ) : (
                        <div className="userValue credits-value">
                          {lbCredits || '0'}
                        </div>
                      )}
                      <div className="userValue status-value">
                        {status || '-'}
                      </div>
                      <div className="userValue icon">
                        {role && role.toLowerCase() !== 'admin' ? (
                          <DeleteToIcon
                            className="svg-icon"
                            title="Remove User"
                            data-memid={memberId}
                            data-email={emailId}
                            onClick={blockUser}
                          />
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  );
              })}
          </div>
        </section>
      </div>
    </div>
  );
});

export default TeamManage;
export { TeamManage };
